export interface BatchStatusInfo {
  icon: string;
  label: string;
  color: string;
  bgColor: string;
}

/** Capitalize first letter of each camelCase/PascalCase segment for display. */
export function toPascalCase(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

const statusMap: Record<string, BatchStatusInfo> = {
  completed: { icon: "✅", label: "Completed", color: "#107C10", bgColor: "#DFF6DD" },
  staging: { icon: "🟡", label: "Staging", color: "#797600", bgColor: "#FFF4CE" },
  buffering: { icon: "⏳", label: "Buffering", color: "#986F0B", bgColor: "#FFF4CE" },
  sent: { icon: "🔵", label: "Sent", color: "#0078D4", bgColor: "#DEECF9" },
  readytosend: { icon: "🟠", label: "Ready", color: "#CA5010", bgColor: "#FED9CC" },
  failed: { icon: "🔴", label: "Failed", color: "#D13438", bgColor: "#FDE7E9" },
};

export function getStatusIconAriaHidden(): boolean {
  return true;
}

export function getStatusInfo(status: string): BatchStatusInfo {
  return statusMap[status.toLowerCase()] || { icon: "⚪", label: toPascalCase(status), color: "#605E5C", bgColor: "#F3F2F1" };
}

export function formatDateTime(dateStr: string | null, useUtc: boolean): string {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  if (useUtc) {
    return date.toISOString().replace("T", " ").substring(0, 19) + " UTC";
  }
  return date.toLocaleString();
}

export function formatPeriod(start: string | null, end: string | null): string {
  if (!start || !end) return "—";
  const s = new Date(start);
  const e = new Date(end);
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${monthNames[s.getMonth()]} ${s.getDate()} – ${monthNames[e.getMonth()]} ${e.getDate()}, ${e.getFullYear()}`;
}
